import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class UpdatePaymentSource {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * UpdatePaymentSource constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle updating the authenticated user's card details in the payment gateway.
     *
     * @param {int} userId
     * @param {string} cardToken
     * @param {string} cardId
     * @param {string} nameOnCard
     *
     * @returns {Promise}
     */
    handle(userId, cardToken, cardId, nameOnCard, paymentMethod) {
        let apiUrl = prepareUrl(ApiEndpoints['payments.payment-sources.update'], [userId]);

        let payload = {
            card_token: cardToken,
            card_id: cardId,
            gateway: 'Stripe',
            name_on_card: nameOnCard,
            payment_method: paymentMethod,
        };

        return this.apiService.patch(apiUrl, payload);
    }
}
